var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      placeholder: "Client Status",
      multiple: false,
      value: _vm.value,
      options: _vm.statusOptions,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }